import type { DevicePort } from "./types";

const DEVICE_ID_KEY = "hamlak.deviceId";

// 인앱 브라우저 User-Agent 표식(카카오톡·인스타그램·페이스북·라인·네이버·다음 + 일반 Android WebView).
const IN_APP_UA = /KAKAOTALK|Instagram|FBAN|FBAV|FB_IAB|Line\/|NAVER\(|DaumApps|; wv\)/i;

export const isInAppBrowserUa = (ua: string): boolean => IN_APP_UA.test(ua);

function readOrCreateDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing) return existing;
    const created = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, created);
    return created;
  } catch {
    // 저장이 막힌 환경(시크릿·저장소 차단)은 세션 동안만 유지되는 값으로 간다.
    return crypto.randomUUID();
  }
}

/** User-Agent에서 OS 요약(고객센터 자동 첨부). 정확한 모델명은 웹에서 알 수 없어 "web"으로 둔다. */
export function summarizeOs(ua: string): string {
  const m = /(Android [\d.]+|iPhone OS [\d_]+|Mac OS X [\d_]+|Windows NT [\d.]+|CrOS [^;)]+|Linux)/.exec(ua);
  return m ? m[1]!.replace(/_/g, ".") : "unknown";
}

export const webDevice: DevicePort = {
  getDeviceId: async () => readOrCreateDeviceId(),
  isInAppBrowser: () => isInAppBrowserUa(navigator.userAgent),
  copy: async (text) => navigator.clipboard.writeText(text),
  getInfo: async () => ({ model: "web", os: summarizeOs(navigator.userAgent) }),
  share: async ({ title, url }) => {
    if (typeof navigator.share === "function") {
      try {
        await navigator.share({ title, url });
        return "shared";
      } catch (e) {
        if (e instanceof DOMException && e.name === "AbortError") return "dismissed";
        // NotAllowedError 등(사용자 제스처 밖·권한): 복사로 폴백
      }
    }
    await navigator.clipboard.writeText(url);
    return "copied";
  },
  // secureStore 없음: 웹은 access·refresh 모두 httpOnly 쿠키라 JS 보관이 없다.
};
